import axios from "axios";
import apiClient from "../../app/apiClient";

// Public requests must not depend on an existing login or an expired token.
const publicClient = axios.create({ baseURL: apiClient.defaults.baseURL });
export const PUBLIC_PROJECTS_PATH = "/public/projects";
export const PROJECT_PAGE_SIZE = 6;

const enumLabel = (value) => String(value || "").toLowerCase().replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
const imageUrl = (value) => {
  if (typeof value !== "string" || !value.trim()) return null;
  try { return new URL(value, publicClient.defaults.baseURL).href; } catch { return null; }
};

export function toPublicProject(record) {
  const images = (record.previewImages || []).map(imageUrl).filter(Boolean);
  return {
    ...record,
    title: record.projectCode || String(record.id),
    area: record.area == null ? "Not specified" : `${Number(record.area).toLocaleString("en-IN")} sq ft`,
    floorLabel: record.foundation || "Not specified",
    category: enumLabel(record.category),
    status: enumLabel(record.status),
    imageUrl: images[0],
    images,
  };
}

export async function getPublicProjects(page = 0, signal) {
  const { data } = await publicClient.get(PUBLIC_PROJECTS_PATH, { params: { page, size: PROJECT_PAGE_SIZE }, signal });
  const records = Array.isArray(data) ? data : data?.content ?? data?.items;
  if (!Array.isArray(records)) throw new Error("The server returned an unexpected projects response.");
  // A plain list is complete; paginated responses retain server pagination.
  const hasNext = !Array.isArray(data) && (data.hasNext ?? (typeof data.last === "boolean" ? !data.last :
    typeof data.totalPages === "number" ? page + 1 < data.totalPages :
    typeof data.totalElements === "number" ? (page + 1) * PROJECT_PAGE_SIZE < data.totalElements : records.length === PROJECT_PAGE_SIZE));
  return { projects: records.map(toPublicProject), hasNext: Boolean(hasNext) };
}
